import { cancellationReasonKeys } from "@utils/constants/deliveryCancelReasons";
import { z } from "zod";

import errorMessages from "../error-messages";

const CancelDeliverySchema = z
  .object({
    reason: z.enum(cancellationReasonKeys, {
      error: (issue) =>
        issue.input === undefined ? errorMessages.required : errorMessages.required,
    }),
    additionalInfo: z.string().optional(), // Optional field for additional notes
  })
  .refine(
    (data) => {
      // Enforce that 'additionalInfo' must be provided if the 'reason' is 'other'
      if (data.reason === "other" && (!data.additionalInfo || data.additionalInfo.trim() === "")) {
        return false;
      }
      return true;
    },
    {
      message: errorMessages.required,
      path: ["additionalInfo"], // The path to the field that needs additional validation
    }
  );

type TCancelDelivery = z.infer<typeof CancelDeliverySchema>;

export default CancelDeliverySchema;
export type { TCancelDelivery };
